<template>
  <div class="d-flex justify-content-center align-items-center bg-gradient mt-auto">
    <div class="card shadow-lg p-4 rounded-4" style="width: 100%; max-width: 400px;">
      <h2 class="text-center mb-4 fw-semibold">Crea un nuovo Preventivo</h2>
      <p class="text-center text-muted mb-4">Scegli come iniziare il tuo preventivo</p>

      <button type="button" class="btn btn-success w-100 mb-3 py-3 rounded-pill fw-medium" @click="modSys.show()">
        Da Sistema
      </button>

      <button type="button" class="btn btn-outline-success w-100 py-3 rounded-pill fw-medium" @click="modBases.show()">
        Da Superficie
      </button>
    </div>
  </div>

  <div id="modalSystems" class="modal modal-fullscreen fade" tabindex="-1" role="dialog" aria-labelledby="myModalLabel"
    aria-hidden="true" ref="modalSystems">
    <div class="modal-dialog modal-fullscreen">
      <div class="modal-content shadow-lg rounded">
        <div class="modal-header border-0">
          <h5 class="modal-title text-center w-100">Seleziona un Sistema</h5>
          <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
        </div>

        <div class="modal-body d-flex flex-column align-items-center">
          <!-- Search Input -->
          <div class="d-flex justify-content-center mb-4">
            <input type="text" v-model="searchS" class="form-control form-control-lg rounded-pill"
              placeholder="Cerca..." style="max-width: 500px; width: 100%;" />
          </div>

          <!-- System Selection Buttons -->
          <div class="d-flex flex-wrap justify-content-center gap-3">
            <button v-for="(system, i) in filteredSystems" :key="i" class="btn btn-success rounded-pill px-4 py-3"
              @click="selected.system = system; handleModals('system')"
              :disabled="selected.base.systems && !selected.base.systems.find(e => e.id == system.id)"
              >
              {{ system.system_name }}
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div id="modalBases" class="modal modal-fullscreen fade" tabindex="-1" role="dialog" aria-labelledby="myModalLabel"
    aria-hidden="true" ref="modalBases">
    <div class="modal-dialog modal-fullscreen">
      <div class="modal-content shadow-lg rounded">
        <div class="modal-header border-0">
          <h5 class="modal-title text-center w-100">Seleziona una Superficie</h5>
          <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
        </div>

        <div class="modal-body d-flex flex-column align-items-center">
          <!-- Search Input -->
          <div class="d-flex justify-content-center mb-4">
            <input type="text" v-model="searchB" class="form-control form-control-lg rounded-pill"
              placeholder="Cerca..." style="max-width: 500px; width: 100%;" />
          </div>

          <!-- Base Selection Buttons -->
          <div class="d-flex flex-wrap justify-content-center gap-3">
            <button v-for="(base, i) in filteredBases" :key="i" class="btn btn-success rounded-pill px-4 py-3"
              @click="selected.base = base; handleModals('base')"
              :disabled="selected.system.bases && !selected.system.bases.find(e => e.id == base.id)">
              {{ base.base_name }}
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div id="modalMQ" class="modal modal-fullscreen fade" tabindex="-1" role="dialog" aria-labelledby="myModalLabel"
    aria-hidden="true" ref="modalMQ">
    <div class="modal-dialog modal-fullscreen">
      <div class="modal-content shadow-lg rounded">
        <div class="modal-header border-0">
          <h5 class="modal-title text-center w-100">Inserisci una metratura</h5>
          <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
        </div>

        <div class="modal-body d-flex flex-column align-items-center justify-content-center">
          <!-- Metratura Input -->
          <div class="d-flex flex-column align-items-center mb-4">
            <div class="input-container position-relative">
              <input type="number" min="0" v-model="selected.mq" class="form-control rounded-pill py-3 text-center"
                style="width: 150px;" />
              <span class="position-absolute end-0 top-50 translate-middle-y me-5 suffix">mq</span>
            </div>
          </div>

          <!-- Create Preventivo Button -->
          <button class="btn btn-success px-5 py-3 rounded-pill" @click="handleModals('mq')">Crea Preventivo</button>
        </div>
      </div>
    </div>
  </div>



</template>

<script>
// @ is an alias to /src
import { onMounted, ref, computed } from 'vue'
import systemMethods from '../api/resources/systemMethods'
import productMethods from '../api/resources/productMethods'
import router from '../router/index.js'
import { Modal } from 'bootstrap'
export default {
  name: 'HomeView',
  setup() {
    var modSys = ref(Modal);
    var modBases = ref(Modal);
    var modMQ = ref(Modal);
    const modalSystems = ref(null);
    const modalBases = ref(null);
    const modalMQ = ref(null);

    const systems = ref([]);
    const searchS = ref("");
    const bases = ref([]);
    const searchB = ref("");

    function toOrder() {
      router.push({ path: "/order", query: { id: 123 } })
    }
    const selected = ref({
      system: 0,
      base: 0,
      mq: 0,
    })

    onMounted(async () => {
      modSys.value = new Modal(modalSystems.value)
      util(modSys.value);
      modBases.value = new Modal(modalBases.value)
      util(modBases.value);
      modMQ.value = new Modal(modalMQ.value)
      util(modMQ.value);
      let data = await systemMethods.getSystems();
      let dataB = await productMethods.getBases();
      systems.value = data.data;
      bases.value = dataB.data;
    })

    function util(modal) {
      let oldHide = modal.hide;
      let newHide = function () {
        oldHide.apply(this, arguments)
        selected.value = {
          system: 0,
          base: 0,
          mq: 0,
        }
      }
      modal.hide = newHide
    }

    function handleModals(from) {
      let sel = selected.value;
      if (from == 'system') {
        if (selected.value.base != 0) {
          modSys.value.hide();
          selected.value = sel;
          modMQ.value.show();
        }
        else {
          modSys.value.hide();
          selected.value = sel;
          modBases.value.show();
        }
      }
      if (from == 'base') {
        if (selected.value.system != 0) {
          modBases.value.hide();
          selected.value = sel;
          modMQ.value.show();
        }
        else {
          modBases.value.hide();
          selected.value = sel;
          modSys.value.show();
        }
      }
      if (from == 'mq') {
        modMQ.value.hide();
        selected.value = sel;
        router.push({
          path: "/order", query: {
            system: sel.system.id,
            base: sel.base.id,
            mq: sel.mq,
          }
        })
      }
    }

    const filteredSystems = computed(() => {
      if (searchS.value == "") {
        return systems.value;
      }
      else {
        return systems.value.filter((e) => e.system_name.toLowerCase().includes(searchS.value.toLowerCase()))
      }
    })

    const filteredBases = computed(() => {
      if (searchB.value == "") {
        return bases.value;
      }
      else {
        return bases.value.filter((e) => e.base_name.toLowerCase().includes(searchB.value.toLowerCase()))
      }
    })



    return {
      toOrder,
      modalSystems, modalBases, modalMQ, modSys, modBases, modMQ, handleModals,
      filteredSystems, filteredBases, bases, selected, searchS, searchB
    }

  }
}
</script>
<style>
.input-container {
  position: relative;
  display: inline-block;
}

.suffix {
  position: absolute;
  right: 35px;
  top: 50%;
  transform: translateY(-50%);
  color: gray;
  pointer-events: none;
  font-size: 14px;
}
.separator {
    border-bottom: 1mm dotted grey
}

.accordion-button:not(.collapsed) {
    background-color: #157347 !important;
    color: white !important;
}

.accordion-button.collapsed {
    background-color: #15734725;
}
</style>
